goog.provide('el8.appchart.dialog.ordermed.viewRxOrderSets');

goog.require('el8.uiwidget.Component');
goog.require('el8.uiwidget.ComponentDialog');
goog.require('el8.template.appchart.dialog.ordermed.viewRxOrderSets');
goog.require('el8.practicedata.medOrderTemplates');

// This is the "view and apply" dialog that is accessed from the top bar for Rx Templates
// (aka medOrderTemplates). Note: sort order is respected
el8.appchart.dialog.ordermed.viewRxOrderSets = (function() {
    var _selectFn = null;

    var that = new el8.uiwidget.ComponentDialog({
        title: 'Rx Templates',
        height: 500,
        width: 500,
        contentFn: el8.template.appchart.dialog.ordermed.viewRxOrderSets.content
    });

    var component = new el8.uiwidget.Component({
        showFn: function() {
            $('#view-rx-order-sets-list', that.getContentElt()).addClass('dataLoading');
        },
        dataRenderers: [
            {
                entitySet: el8.practicedata.medOrderTemplates,
                renderFn: function() {
                    $('#view-rx-order-sets-list', that.getContentElt()).html(
                        el8.template.appchart.dialog.ordermed.viewRxOrderSets.list({
                            orderSets: el8.practicedata.medOrderTemplates.allAsSoyMaps()
                        })
                    ).removeClass('dataLoading');
                },
                events: [{eventName: 'all'}]
            }
        ]
    });
    that.setComponent(component);

    var super_init = that._init;
    that._init = function() {
        super_init.call(that);
        that._bindTriggers();
    };

    var super_show = that.show;
    that.show = function(doLoad, selectFn) {
        super_show.call(that, doLoad);
        _selectFn = selectFn;
    };

    that._bindTriggers = function() {
        that.getContentElt().on('click', '.select-trigger',  function() {
            var itemId = $(this).closest('.order-set-item').data('id');
            if (_selectFn) { _selectFn(itemId); }
            that.hide();
            return false;
        });
    };

    return that;
})();
